// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/roboto/Roboto-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/roboto/Roboto-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/roboto/Roboto-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/roboto/Roboto-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'roboto';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
	url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
	font-weight: normal;
	font-style: normal;
}

@font-face {
	font-family: 'roboto';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
	url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
	font-weight: bold;
	font-style: normal;
}



:root {
	/* color palette https://huemint.com/website-2/#palette=32375c-ffbe98-52c8c2-fc7184 */
	--medieval-blue: #32375c;
	--medieval-blue-tint: #565b7b;
	--peach-fuzz: #ffbe98;
	--peach-fuzz-tint: #ffece0;
	--peppy-peacock: #52c8c2;
	--anime-blush: #fc7184;
	--anime-blush-tint: #ffd6d9;
}

html {
	font-size: calc(16px + (26 - 16) * ((100vw - 300px) / (2800 - 300)));
}

/*
* {
	border: 1px solid red;
}
*/

body {
	background-color: var(--medieval-blue-tint);
	font-family: roboto, Arial, Helvetica, sans-serif;
}

/* homepage CSS */
.app {
	display: flex;
	height: 100vh;
}

.menu-toggle {
	display: none;
	position: fixed;
	top: 2rem;
	right: 2rem;
	width: 60px;
	height: 60px;
	border-radius: 99px;
	background-color: var(--peach-fuzz);
	cursor: pointer;
}

.hamburger {
	position: relative;
	top: calc(50% - 2px);
	left: 50%;
	transform: translate(-50%, -50%);
	width: 32px;
}

.hamburger > span,
.hamburger > span::before,
.hamburger > span::after {
	display: block;
	position: absolute;
	width: 100%;
	height: 4px;
	border-radius: 99px;
	background-color: var(--medieval-blue);
	transition-duration: 0.25s;
}

.hamburger > span::before {
	content: "";
	top: -8px;
}
.hamburger > span::after {
	content: "";
	top: 8px;
}
.menu-toggle.is-active .hamburger > span {
	transform: rotate(45deg);
}
.menu-toggle.is-active .hamburger > span::before {
	top: 0;
	transform: rotate(0deg);
}
.menu-toggle.is-active .hamburger > span::after {
	top: 0;
	transform: rotate(90deg);
}

.sidebar {
	flex: 1 1 0;
	max-width: 300px;
	/*height: 100%;*/
	padding: 2rem 1rem;
	background-color: var(--medieval-blue);
	box-shadow:
	0px 3px 5px -1px rgba(0, 0, 0, 0.2),
	0px 6px 10px 0px rgba(0, 0, 0, 0.14),
	0px 1px 18px 0px rgba(0,0,0,.12);
	overflow: auto;
}

.sidebar h2 {
	color: var(--peach-fuzz);
	font-family: roboto, Arial, Helvetica, sans-serif;
	font-size: 1.3rem;
	text-transform: uppercase;
	margin-bottom: 0.5em;
	text-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
}

.sidebar .menu {
	margin: 0 -1rem;
}

.sidebar .menu .menu-item {
	display: flex; /* original was: \`display: block\` */
	align-items: center; /* was not here originally */
	padding: 1em;
	color: var(--peach-fuzz-tint);
	text-decoration: none;
	transition: 0.2s linear;
}

.sidebar .menu .menu-item:hover,
.sidebar .menu .menu-item.is-active {
	color: var(--peppy-peacock);
	border-right: 5px solid var(--peppy-peacock);
}

.sidebar .menu .menu-item:hover {
	border-right: 5px solid var(--peppy-peacock);
}

/* Projects section in sidebar */
/* styling add project area */
.project-container-header-container {
	display: flex;
	align-items: center;
	padding: 1em;
	/*text-decoration: none;*/
}

.project-container-header {
	color: var(--peppy-peacock);
	font-weight: 900;
	text-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	margin-right: auto;
}

.add-project-button {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 2rem;
	height: 2rem;
	background-color: var(--peppy-peacock);
	color: var(--medieval-blue);
	font-size: 1.3rem;
	font-weight: 900;
	border: none;
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border-radius: 5px;
	padding: 10px 10px;
}

/*Modal when adding a new project*/
.project-dialog-element {
	background-color: var(--medieval-blue);
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.add-project-form {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.project-dialog-element > div {
	color: var(--peach-fuzz-tint);
}

.project-form-input {
	background-color: var(--peach-fuzz-tint);
	color: var(--medieval-blue);
	border: none;
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
}

.project-submit-button {
	background-color: var(--peppy-peacock);
	padding: 10px 20px;
	color: var(--medieval-blue);
	border: none;
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
}

.project-cancel-button {
	background-color: var(--anime-blush);
	padding: 10px 20px;
	color: var(--medieval-blue);
	border: none;
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
}

/* submitted projects */
.project-button {
	color: var(--peach-fuzz-tint);
	text-decoration: none;
}

.project-button:hover {
	color: var(--peppy-peacock);
}

.project-delete-button {
	background-color: var(--anime-blush);
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	border-radius: 5px;
}

.project-delete-button > svg {
	fill: var(--medieval-blue);
}

/* task content area */
.content {
	flex: 1 1 0;
	padding: 2rem;
	overflow: auto;
}

.content h1 {
	color: var(--anime-blush);
	font-size: 2.5rem;
	margin-bottom: 1rem;
	text-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
}

.add-task-button {
	background-color: var(--peppy-peacock);
	color: var(--medieval-blue);
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	border-radius: 5px;
}

.ui-tasks-container {
	display: flex;
	flex-direction: column;
	gap: 25px;
}

/* individual tasks in the content area */

.task-container {
	display: flex;
	gap: 10px;
	align-items: center;
	border: 1px solid var(--medieval-blue);
	border-radius: 5px;
	padding: 8px;
}

.task-container:hover {
	box-shadow:
	0px 3px 5px -1px rgba(0, 0, 0, 0.2),
	0px 6px 10px 0px rgba(0, 0, 0, 0.14),
	0px 1px 18px 0px rgba(0,0,0,.12);
}

/*
.task-checkbox {
	background: red;
}
*/

.task-name {
	color: var(--anime-blush-tint);
	margin-right: auto;
	flex-grow: 2;
}

.task-controls-container {
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: flex-end;
	justify-content: center;
	flex-grow: 1;
}

.task-date {
	background-color: var(--anime-blush-tint);
	color: var(--medieval-blue);
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	border-radius: 5px;
	padding: 2px;
}

.task-buttons-container {
	display: flex;
	gap: 10px;
	align-items: center;
	justify-content: flex-end;
}

.task-details-button {
	background-color: var(--medieval-blue);
	color: var(--anime-blush-tint);
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	border-radius: 5px;
}

.task-edit-button {
	background-color: var(--peppy-peacock);
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	border-radius: 5px;
}

.task-edit-button > svg {
	fill: var(--medieval-blue);
}

.task-delete-button {
	background-color: var(--anime-blush);
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	border-radius: 5px;
}

.task-delete-button > svg {
	fill: var(--medieval-blue);
}

.done-tasks-container {
	display: flex;
	flex-direction: column;
	/*gap: 25px;*/
	/* Vendor prefixes */
	/*-webkit-gap: 25px;
	-moz-gap: 25px;
	-ms-gap: 25px;*/
}

.done-tasks-container > div:not(:last-child) {
	margin-bottom: 25px;
}

.done-tasks-container summary {
	color: var(--anime-blush-tint);
	margin-bottom: 15px;
	cursor: pointer;
}

/* individual task styling for filtered tasks */
.filter-task-container {
	display: flex;
	gap: 10px;
	align-items: center;
	border: 1px solid var(--medieval-blue);
	border-radius: 5px;
	padding: 8px;
}

.filter-task-container:hover {
	box-shadow:
	0px 3px 5px -1px rgba(0, 0, 0, 0.2),
	0px 6px 10px 0px rgba(0, 0, 0, 0.14),
	0px 1px 18px 0px rgba(0,0,0,.12);
}

.filter-task-name {
	color: var(--anime-blush-tint);
	margin-right: auto;
}

.filter-task-date {
	background-color: var(--anime-blush-tint);
	color: var(--medieval-blue);
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	border-radius: 5px;
	padding: 2px;
	/*make the date tag stay on one line*/
	white-space: nowrap;
}

.filter-task-details-button {
	background-color: var(--medieval-blue);
	color: var(--anime-blush-tint);
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	padding: 5px;
	border-radius: 5px;
}



/* task priority colors */
.high-priority-task {
	border-left: 3px solid var(--anime-blush);
}

.medium-priority-task {
	border-left: 3px solid var(--peach-fuzz);
}

.low-priority-task {
	border-left: 3px solid var(--peppy-peacock);
}

/* task info modal */
.task-info-modal {
	display: flex;
	gap: 10px;
	flex-direction: column;
	background-color: var(--medieval-blue);
}

.info-modal-header-container {
	display: flex;
}

.info-modal-header-container > h2 {
	color: var(--anime-blush-tint);
	margin-right: auto;
}

.info-modal-header-container > button {
	width: 1.5rem;
	height: 1.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: var(--anime-blush);
	color: var(--medieval-blue);
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	border-radius: 5px;
	/*aspect-ratio: 1 / 1;*/
}

.task-info-modal div {
	color: var(--anime-blush-tint);
}

/* task edit modal */
.task-dialog-element {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 20px;
	background-color: var(--medieval-blue);
}

/*
.add-task-form {
	display: flex;
	flex-direction: column;
	gap: 10px;
}
*/

.add-task-form {
	display: flex;
	flex-direction: column;
	gap: 10px;
	/*width: 300px; /* Adjust width as needed */
}

.task-dialog-element label {
	font-weight: bold;
	color: var(--anime-blush-tint);
}

.add-task-form textarea,
.add-task-form input[type="text"],
.add-task-form input[type="date"] {
	width: 100%;
	padding: 5px;
	/*border: 1px solid #ccc;*/
	border: none;
	border-radius: 5px;
	margin-top: 7px;
	background-color: var(--anime-blush-tint);
	color: var(--medieval-blue);
}

.add-task-form fieldset {
	border: none;
	margin: 0;
	padding: 0;
	display: flex;
	gap: 10px;
}

.button-container {
	display: flex;
	gap: 15px;
}

.add-task-form .edit-button,
.add-task-form .submit-button {
	padding: 10px 20px;
	margin-top: 10px;
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	background-color: var(--peppy-peacock);
	color: var(--medieval-blue);
	cursor: pointer;
}

.add-task-form .cancel-button {
	padding: 10px 20px;
	margin-top: 10px;
	box-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);
	border: none;
	background-color: var(--anime-blush);
	color: var(--medieval-blue);
	cursor: pointer;
}

/* media queries */
@media (max-width: 1024px) {
	.sidebar {
		max-width: 200px;
	}
}

@media (max-width: 768px) {
	.menu-toggle {
		display: block;
	}
	.content {
		padding-top: 8rem;
	}
	.sidebar {
		position: fixed;
		top: 0;
		left: -300px;
		height: 100vh;
		width: 100%;
		max-width: 60vw;
		transition: 0.2s linear;
	}

	.sidebar.is-active {
		left: 0;
	}
}



/*
.project-container {
	display: flex;
	color: #fff;
}
*/

.project-button {
	margin-right: auto;
	padding: none;
	text-decoration: none;
}

.project-delete-button {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 5px;
}

.project-delete-button > * {
	pointer-events: none;
}

.project-delete-icon {
	width: 25px;
	margin: 0;
	padding: 0;
}

/* content heading / project heading and add task button */
.welcome-heading {
	display: flex;
}

.add-task-button {
	margin-left: auto;
}

.task-edit-button,
.task-delete-button {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 0;
}

.task-edit-icon,
.task-delete-icon {
	width: 25px;
	margin: 0;
	padding: 0;
}

.hide {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;CACC,qBAAqB;CACrB;uDACyD;CACzD,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB;uDACsD;CACtD,iBAAiB;CACjB,kBAAkB;AACnB;;;;AAIA;CACC,qFAAqF;CACrF,wBAAwB;CACxB,6BAA6B;CAC7B,qBAAqB;CACrB,0BAA0B;CAC1B,wBAAwB;CACxB,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,oEAAoE;AACrE;;AAEA;;;;CAIC;;AAED;CACC,2CAA2C;CAC3C,iDAAiD;AAClD;;AAEA,iBAAiB;AACjB;CACC,aAAa;CACb,aAAa;AACd;;AAEA;CACC,aAAa;CACb,eAAe;CACf,SAAS;CACT,WAAW;CACX,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,mCAAmC;CACnC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,SAAS;CACT,gCAAgC;CAChC,WAAW;AACZ;;AAEA;;;CAGC,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,sCAAsC;CACtC,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,SAAS;AACV;AACA;CACC,WAAW;CACX,QAAQ;AACT;AACA;CACC,wBAAwB;AACzB;AACA;CACC,MAAM;CACN,uBAAuB;AACxB;AACA;CACC,MAAM;CACN,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,sCAAsC;CACtC;;;iCAGgC;CAChC,cAAc;AACf;;AAEA;CACC,wBAAwB;CACxB,iDAAiD;CACjD,iBAAiB;CACjB,yBAAyB;CACzB,oBAAoB;CACpB,4CAA4C;AAC7C;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa,EAAE,mCAAmC;CAClD,mBAAmB,EAAE,4BAA4B;CACjD,YAAY;CACZ,6BAA6B;CAC7B,qBAAqB;CACrB,uBAAuB;AACxB;;AAEA;;CAEC,2BAA2B;CAC3B,4CAA4C;AAC7C;;AAEA;CACC,4CAA4C;AAC7C;;AAEA,gCAAgC;AAChC,6BAA6B;AAC7B;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;CAChB,4CAA4C;CAC5C,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,sCAAsC;CACtC,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;CAChB,YAAY;CACZ,2CAA2C;CAC3C,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA,kCAAkC;AAClC;CACC,sCAAsC;CACtC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,wCAAwC;CACxC,2BAA2B;CAC3B,YAAY;CACZ,2CAA2C;AAC5C;;AAEA;CACC,sCAAsC;CACtC,kBAAkB;CAClB,2BAA2B;CAC3B,YAAY;CACZ,2CAA2C;AAC5C;;AAEA;CACC,oCAAoC;CACpC,kBAAkB;CAClB,2BAA2B;CAC3B,YAAY;CACZ,2CAA2C;AAC5C;;AAEA,uBAAuB;AACvB;CACC,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,oCAAoC;CACpC,2CAA2C;CAC3C,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA,sBAAsB;AACtB;CACC,WAAW;CACX,aAAa;CACb,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;CACjB,mBAAmB;CACnB,4CAA4C;AAC7C;;AAEA;CACC,sCAAsC;CACtC,2BAA2B;CAC3B,2CAA2C;CAC3C,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA,yCAAyC;;AAEzC;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,sCAAsC;CACtC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC;;;iCAGgC;AACjC;;AAEA;;;;CAIC;;AAED;CACC,8BAA8B;CAC9B,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,qBAAqB;CACrB,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,yCAAyC;CACzC,2BAA2B;CAC3B,2CAA2C;CAC3C,YAAY;CACZ,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;CACtC,8BAA8B;CAC9B,2CAA2C;CAC3C,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,sCAAsC;CACtC,2CAA2C;CAC3C,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,oCAAoC;CACpC,2CAA2C;CAC3C,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,oBAAoB;CACpB;;gBAEe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;CACnB,eAAe;AAChB;;AAEA,+CAA+C;AAC/C;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,sCAAsC;CACtC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC;;;iCAGgC;AACjC;;AAEA;CACC,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC,yCAAyC;CACzC,2BAA2B;CAC3B,2CAA2C;CAC3C,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,qCAAqC;CACrC,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;CACtC,8BAA8B;CAC9B,2CAA2C;CAC3C,YAAY;CACZ,YAAY;CACZ,kBAAkB;AACnB;;;;AAIA,yBAAyB;AACzB;CACC,yCAAyC;AAC1C;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,2CAA2C;AAC5C;;AAEA,oBAAoB;AACpB;CACC,aAAa;CACb,SAAS;CACT,sBAAsB;CACtB,sCAAsC;AACvC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,oCAAoC;CACpC,2BAA2B;CAC3B,2CAA2C;CAC3C,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;AACxB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,oBAAoB;AACpB;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,aAAa;CACb,sCAAsC;AACvC;;AAEA;;;;;;CAMC;;AAED;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,2CAA2C;AAC5C;;AAEA;CACC,iBAAiB;CACjB,8BAA8B;AAC/B;;AAEA;;;CAGC,WAAW;CACX,YAAY;CACZ,0BAA0B;CAC1B,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,yCAAyC;CACzC,2BAA2B;AAC5B;;AAEA;CACC,YAAY;CACZ,SAAS;CACT,UAAU;CACV,aAAa;CACb,SAAS;AACV;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;;CAEC,kBAAkB;CAClB,gBAAgB;CAChB,2CAA2C;CAC3C,YAAY;CACZ,sCAAsC;CACtC,2BAA2B;CAC3B,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,2CAA2C;CAC3C,YAAY;CACZ,oCAAoC;CACpC,2BAA2B;CAC3B,eAAe;AAChB;;AAEA,kBAAkB;AAClB;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,cAAc;CACf;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,MAAM;EACN,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;CACxB;;CAEA;EACC,OAAO;CACR;AACD;;;;AAIA;;;;;CAKC;;AAED;CACC,kBAAkB;CAClB,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,SAAS;CACT,UAAU;AACX;;AAEA,0DAA0D;AAC1D;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;CAEC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,UAAU;AACX;;AAEA;;CAEC,WAAW;CACX,SAAS;CACT,UAAU;AACX;;AAEA;CACC,aAAa;AACd","sourcesContent":["@font-face {\n\tfont-family: 'roboto';\n\tsrc: url('../fonts/roboto/Roboto-Regular.woff2') format('woff2'),\n\turl('../fonts/roboto/Roboto-Regular.woff') format('woff');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: 'roboto';\n\tsrc: url('../fonts/roboto/Roboto-Bold.woff2') format('woff2'),\n\turl('../fonts/roboto/Roboto-Bold.woff') format('woff');\n\tfont-weight: bold;\n\tfont-style: normal;\n}\n\n\n\n:root {\n\t/* color palette https://huemint.com/website-2/#palette=32375c-ffbe98-52c8c2-fc7184 */\n\t--medieval-blue: #32375c;\n\t--medieval-blue-tint: #565b7b;\n\t--peach-fuzz: #ffbe98;\n\t--peach-fuzz-tint: #ffece0;\n\t--peppy-peacock: #52c8c2;\n\t--anime-blush: #fc7184;\n\t--anime-blush-tint: #ffd6d9;\n}\n\nhtml {\n\tfont-size: calc(16px + (26 - 16) * ((100vw - 300px) / (2800 - 300)));\n}\n\n/*\n* {\n\tborder: 1px solid red;\n}\n*/\n\nbody {\n\tbackground-color: var(--medieval-blue-tint);\n\tfont-family: roboto, Arial, Helvetica, sans-serif;\n}\n\n/* homepage CSS */\n.app {\n\tdisplay: flex;\n\theight: 100vh;\n}\n\n.menu-toggle {\n\tdisplay: none;\n\tposition: fixed;\n\ttop: 2rem;\n\tright: 2rem;\n\twidth: 60px;\n\theight: 60px;\n\tborder-radius: 99px;\n\tbackground-color: var(--peach-fuzz);\n\tcursor: pointer;\n}\n\n.hamburger {\n\tposition: relative;\n\ttop: calc(50% - 2px);\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 32px;\n}\n\n.hamburger > span,\n.hamburger > span::before,\n.hamburger > span::after {\n\tdisplay: block;\n\tposition: absolute;\n\twidth: 100%;\n\theight: 4px;\n\tborder-radius: 99px;\n\tbackground-color: var(--medieval-blue);\n\ttransition-duration: 0.25s;\n}\n\n.hamburger > span::before {\n\tcontent: \"\";\n\ttop: -8px;\n}\n.hamburger > span::after {\n\tcontent: \"\";\n\ttop: 8px;\n}\n.menu-toggle.is-active .hamburger > span {\n\ttransform: rotate(45deg);\n}\n.menu-toggle.is-active .hamburger > span::before {\n\ttop: 0;\n\ttransform: rotate(0deg);\n}\n.menu-toggle.is-active .hamburger > span::after {\n\ttop: 0;\n\ttransform: rotate(90deg);\n}\n\n.sidebar {\n\tflex: 1 1 0;\n\tmax-width: 300px;\n\t/*height: 100%;*/\n\tpadding: 2rem 1rem;\n\tbackground-color: var(--medieval-blue);\n\tbox-shadow:\n\t0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n\t0px 6px 10px 0px rgba(0, 0, 0, 0.14),\n\t0px 1px 18px 0px rgba(0,0,0,.12);\n\toverflow: auto;\n}\n\n.sidebar h2 {\n\tcolor: var(--peach-fuzz);\n\tfont-family: roboto, Arial, Helvetica, sans-serif;\n\tfont-size: 1.3rem;\n\ttext-transform: uppercase;\n\tmargin-bottom: 0.5em;\n\ttext-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n}\n\n.sidebar .menu {\n\tmargin: 0 -1rem;\n}\n\n.sidebar .menu .menu-item {\n\tdisplay: flex; /* original was: `display: block` */\n\talign-items: center; /* was not here originally */\n\tpadding: 1em;\n\tcolor: var(--peach-fuzz-tint);\n\ttext-decoration: none;\n\ttransition: 0.2s linear;\n}\n\n.sidebar .menu .menu-item:hover,\n.sidebar .menu .menu-item.is-active {\n\tcolor: var(--peppy-peacock);\n\tborder-right: 5px solid var(--peppy-peacock);\n}\n\n.sidebar .menu .menu-item:hover {\n\tborder-right: 5px solid var(--peppy-peacock);\n}\n\n/* Projects section in sidebar */\n/* styling add project area */\n.project-container-header-container {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 1em;\n\t/*text-decoration: none;*/\n}\n\n.project-container-header {\n\tcolor: var(--peppy-peacock);\n\tfont-weight: 900;\n\ttext-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tmargin-right: auto;\n}\n\n.add-project-button {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 2rem;\n\theight: 2rem;\n\tbackground-color: var(--peppy-peacock);\n\tcolor: var(--medieval-blue);\n\tfont-size: 1.3rem;\n\tfont-weight: 900;\n\tborder: none;\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder-radius: 5px;\n\tpadding: 10px 10px;\n}\n\n/*Modal when adding a new project*/\n.project-dialog-element {\n\tbackground-color: var(--medieval-blue);\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n}\n\n.add-project-form {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n}\n\n.project-dialog-element > div {\n\tcolor: var(--peach-fuzz-tint);\n}\n\n.project-form-input {\n\tbackground-color: var(--peach-fuzz-tint);\n\tcolor: var(--medieval-blue);\n\tborder: none;\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n}\n\n.project-submit-button {\n\tbackground-color: var(--peppy-peacock);\n\tpadding: 10px 20px;\n\tcolor: var(--medieval-blue);\n\tborder: none;\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n}\n\n.project-cancel-button {\n\tbackground-color: var(--anime-blush);\n\tpadding: 10px 20px;\n\tcolor: var(--medieval-blue);\n\tborder: none;\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n}\n\n/* submitted projects */\n.project-button {\n\tcolor: var(--peach-fuzz-tint);\n\ttext-decoration: none;\n}\n\n.project-button:hover {\n\tcolor: var(--peppy-peacock);\n}\n\n.project-delete-button {\n\tbackground-color: var(--anime-blush);\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tborder-radius: 5px;\n}\n\n.project-delete-button > svg {\n\tfill: var(--medieval-blue);\n}\n\n/* task content area */\n.content {\n\tflex: 1 1 0;\n\tpadding: 2rem;\n\toverflow: auto;\n}\n\n.content h1 {\n\tcolor: var(--anime-blush);\n\tfont-size: 2.5rem;\n\tmargin-bottom: 1rem;\n\ttext-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n}\n\n.add-task-button {\n\tbackground-color: var(--peppy-peacock);\n\tcolor: var(--medieval-blue);\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tborder-radius: 5px;\n}\n\n.ui-tasks-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 25px;\n}\n\n/* individual tasks in the content area */\n\n.task-container {\n\tdisplay: flex;\n\tgap: 10px;\n\talign-items: center;\n\tborder: 1px solid var(--medieval-blue);\n\tborder-radius: 5px;\n\tpadding: 8px;\n}\n\n.task-container:hover {\n\tbox-shadow:\n\t0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n\t0px 6px 10px 0px rgba(0, 0, 0, 0.14),\n\t0px 1px 18px 0px rgba(0,0,0,.12);\n}\n\n/*\n.task-checkbox {\n\tbackground: red;\n}\n*/\n\n.task-name {\n\tcolor: var(--anime-blush-tint);\n\tmargin-right: auto;\n\tflex-grow: 2;\n}\n\n.task-controls-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\talign-items: flex-end;\n\tjustify-content: center;\n\tflex-grow: 1;\n}\n\n.task-date {\n\tbackground-color: var(--anime-blush-tint);\n\tcolor: var(--medieval-blue);\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tborder-radius: 5px;\n\tpadding: 2px;\n}\n\n.task-buttons-container {\n\tdisplay: flex;\n\tgap: 10px;\n\talign-items: center;\n\tjustify-content: flex-end;\n}\n\n.task-details-button {\n\tbackground-color: var(--medieval-blue);\n\tcolor: var(--anime-blush-tint);\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tborder-radius: 5px;\n}\n\n.task-edit-button {\n\tbackground-color: var(--peppy-peacock);\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tborder-radius: 5px;\n}\n\n.task-edit-button > svg {\n\tfill: var(--medieval-blue);\n}\n\n.task-delete-button {\n\tbackground-color: var(--anime-blush);\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tborder-radius: 5px;\n}\n\n.task-delete-button > svg {\n\tfill: var(--medieval-blue);\n}\n\n.done-tasks-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\t/*gap: 25px;*/\n\t/* Vendor prefixes */\n\t/*-webkit-gap: 25px;\n\t-moz-gap: 25px;\n\t-ms-gap: 25px;*/\n}\n\n.done-tasks-container > div:not(:last-child) {\n\tmargin-bottom: 25px;\n}\n\n.done-tasks-container summary {\n\tcolor: var(--anime-blush-tint);\n\tmargin-bottom: 15px;\n\tcursor: pointer;\n}\n\n/* individual task styling for filtered tasks */\n.filter-task-container {\n\tdisplay: flex;\n\tgap: 10px;\n\talign-items: center;\n\tborder: 1px solid var(--medieval-blue);\n\tborder-radius: 5px;\n\tpadding: 8px;\n}\n\n.filter-task-container:hover {\n\tbox-shadow:\n\t0px 3px 5px -1px rgba(0, 0, 0, 0.2),\n\t0px 6px 10px 0px rgba(0, 0, 0, 0.14),\n\t0px 1px 18px 0px rgba(0,0,0,.12);\n}\n\n.filter-task-name {\n\tcolor: var(--anime-blush-tint);\n\tmargin-right: auto;\n}\n\n.filter-task-date {\n\tbackground-color: var(--anime-blush-tint);\n\tcolor: var(--medieval-blue);\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tborder-radius: 5px;\n\tpadding: 2px;\n\t/*make the date tag stay on one line*/\n\twhite-space: nowrap;\n}\n\n.filter-task-details-button {\n\tbackground-color: var(--medieval-blue);\n\tcolor: var(--anime-blush-tint);\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tpadding: 5px;\n\tborder-radius: 5px;\n}\n\n\n\n/* task priority colors */\n.high-priority-task {\n\tborder-left: 3px solid var(--anime-blush);\n}\n\n.medium-priority-task {\n\tborder-left: 3px solid var(--peach-fuzz);\n}\n\n.low-priority-task {\n\tborder-left: 3px solid var(--peppy-peacock);\n}\n\n/* task info modal */\n.task-info-modal {\n\tdisplay: flex;\n\tgap: 10px;\n\tflex-direction: column;\n\tbackground-color: var(--medieval-blue);\n}\n\n.info-modal-header-container {\n\tdisplay: flex;\n}\n\n.info-modal-header-container > h2 {\n\tcolor: var(--anime-blush-tint);\n\tmargin-right: auto;\n}\n\n.info-modal-header-container > button {\n\twidth: 1.5rem;\n\theight: 1.5rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: var(--anime-blush);\n\tcolor: var(--medieval-blue);\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tborder-radius: 5px;\n\t/*aspect-ratio: 1 / 1;*/\n}\n\n.task-info-modal div {\n\tcolor: var(--anime-blush-tint);\n}\n\n/* task edit modal */\n.task-dialog-element {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tpadding: 20px;\n\tbackground-color: var(--medieval-blue);\n}\n\n/*\n.add-task-form {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n}\n*/\n\n.add-task-form {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\t/*width: 300px; /* Adjust width as needed */\n}\n\n.task-dialog-element label {\n\tfont-weight: bold;\n\tcolor: var(--anime-blush-tint);\n}\n\n.add-task-form textarea,\n.add-task-form input[type=\"text\"],\n.add-task-form input[type=\"date\"] {\n\twidth: 100%;\n\tpadding: 5px;\n\t/*border: 1px solid #ccc;*/\n\tborder: none;\n\tborder-radius: 5px;\n\tmargin-top: 7px;\n\tbackground-color: var(--anime-blush-tint);\n\tcolor: var(--medieval-blue);\n}\n\n.add-task-form fieldset {\n\tborder: none;\n\tmargin: 0;\n\tpadding: 0;\n\tdisplay: flex;\n\tgap: 10px;\n}\n\n.button-container {\n\tdisplay: flex;\n\tgap: 15px;\n}\n\n.add-task-form .edit-button,\n.add-task-form .submit-button {\n\tpadding: 10px 20px;\n\tmargin-top: 10px;\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tbackground-color: var(--peppy-peacock);\n\tcolor: var(--medieval-blue);\n\tcursor: pointer;\n}\n\n.add-task-form .cancel-button {\n\tpadding: 10px 20px;\n\tmargin-top: 10px;\n\tbox-shadow: -1px 3px 2px rgba(0, 0, 0, 0.3);\n\tborder: none;\n\tbackground-color: var(--anime-blush);\n\tcolor: var(--medieval-blue);\n\tcursor: pointer;\n}\n\n/* media queries */\n@media (max-width: 1024px) {\n\t.sidebar {\n\t\tmax-width: 200px;\n\t}\n}\n\n@media (max-width: 768px) {\n\t.menu-toggle {\n\t\tdisplay: block;\n\t}\n\t.content {\n\t\tpadding-top: 8rem;\n\t}\n\t.sidebar {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: -300px;\n\t\theight: 100vh;\n\t\twidth: 100%;\n\t\tmax-width: 60vw;\n\t\ttransition: 0.2s linear;\n\t}\n\n\t.sidebar.is-active {\n\t\tleft: 0;\n\t}\n}\n\n\n\n/*\n.project-container {\n\tdisplay: flex;\n\tcolor: #fff;\n}\n*/\n\n.project-button {\n\tmargin-right: auto;\n\tpadding: none;\n\ttext-decoration: none;\n}\n\n.project-delete-button {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 5px;\n}\n\n.project-delete-button > * {\n\tpointer-events: none;\n}\n\n.project-delete-icon {\n\twidth: 25px;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n/* content heading / project heading and add task button */\n.welcome-heading {\n\tdisplay: flex;\n}\n\n.add-task-button {\n\tmargin-left: auto;\n}\n\n.task-edit-button,\n.task-delete-button {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 0;\n}\n\n.task-edit-icon,\n.task-delete-icon {\n\twidth: 25px;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.hide {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
